/*
Api目录列表
 */
// 学校域名
exports.ip_url = '/api/ip/getAll'; // get
// 登录
exports.login_url = '/auth/login';
// 天喻单点登录
exports.loginsso_url = "/auth/login_sso";
// 小熊创新单点登录
exports.loginsso_xxcx_url = "/auth/login_sso_xxcx";
// 限时信息
exports.deadline_info_url = "/use_deadline_info"


// 导航栏
exports.getBuilds_url = "/control/builds"; // get
// 获取单个网关数据
exports.getGateway_url = "/control/gateway_devices/"; // get // int:id
// 查询网关在线离线状态
exports.getGatewayStatus_url = "/control/gateway/status/"; // get // int:id


// 控制模块请求
var prefix = "/control/mod/";
exports.temperature_url = prefix + "temperature/";
exports.hb01_url = prefix + "hb01/";
exports.all_power_url = prefix + "all_power/";
exports.other_power_url = prefix + "other_power/";
exports.light_url = prefix + "light/";
exports.light3_url = prefix + "light3/";
exports.adjustable_light_url = prefix + "adjustable_light/";
exports.window_curtain_url = prefix + "window_curtain/";
exports.curtain_url = prefix + "curtain/";
exports.ops_url = prefix + "ops/";
exports.projector_url = prefix + "projector/";
exports.fan_url = prefix + "fan/";
exports.airConditioner_url = prefix + "air_conditioner/";
exports.airConditioner2_url = prefix + "air_conditioner2/";
exports.electric_url = prefix + "electric/";
exports.door_url = prefix + "door/";
exports.fourinone_sensor_url = prefix + "fourinone_sensor/";
exports.light_sensor_url = prefix + "light_sensor/";
exports.sound_reinforcement_url = prefix + "sound_reinforcement/";
exports.door_sensor_url = prefix + "door_sensor/";
exports.wall_plug_url = prefix + "wall_plug/";
exports.speed_changeable_fan_url = prefix + "speed_changeable_fan/";
exports.fresh_air_machine_url = prefix + "fresh_air_machine/";
exports.ultraviolet_sterilizer_url = prefix + "ultraviolet_sterilizer/";
exports.air_sterilizer_url = prefix + "air_sterilizer/";
exports.light_sterilizer_url = prefix + "light_sterilizer/";
exports.voice_announcer_url = prefix + "voice_announcer/";
exports.scene_url = "/control/scene/";









// WEBPACK FOOTER //
// ./src/api.js